import { useTranslation } from "react-i18next";
import styles from "../SsnCardVerification.module.scss";

interface ErrorScreenProps {
  /** Terminal error message from the hook; shown beneath the title. */
  message?: string | null;
  consumerLogo?: { src: string; alt: string };
}

/**
 * ErrorScreen — the generic terminal error screen (state `error`), shown for
 * terminal `SsnCardErrorCode`s before the hook posts the error to the parent.
 * Mirrors legal-id's inline error screen (✕ icon + title + message).
 *
 * Recoverable capture failures never reach this screen — they stay in
 * `capturing` and re-run the local capture (SSN-13).
 */
export function ErrorScreen({ message, consumerLogo }: ErrorScreenProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.card}>
      {consumerLogo && (
        <div className={styles.cardConsumerLogoHeader}>
          <img src={consumerLogo.src} alt={consumerLogo.alt} />
          <div className={styles.cardConsumerLogoDivider} />
        </div>
      )}
      <div className={styles.errorIcon} aria-hidden="true">✕</div>
      <h2 className={styles.title}>{t('ssnCard.error.title')}</h2>
      {message && <p className={styles.error}>{message}</p>}
    </div>
  );
}
